import React from "react";
import {NavLink, useHistory, useParams} from "react-router-dom";
import {Button, Divider, Form, Grid, Image} from "semantic-ui-react";
import {useForm} from "react-hook-form";
import {getToken} from "../../../redux/actions";

export const Login = () => {

    const params = useParams();
    const history = useHistory();

    window.scrollTo(0, 0);

    const {register, handleSubmit, formState} = useForm({
        mode: 'onChange',
        defaultValues: {
            username: '',
            password: ''
        }
    });

    const {isValid, isSubmitting} = formState;

    const onSubmit = async data => {
        try {
            const res = await getToken(data);
            const user = res.data.data;

            sessionStorage.setItem('Token', res.data.token)
            sessionStorage.setItem('Data', JSON.stringify(user))

            if (params['return'] === "1") {
                const goback = localStorage.getItem('goback');
                if(goback){
                    localStorage.removeItem(goback);
                    window.location.href = goback;
                    return;
                }
                history.goBack();
                return;
            }

            history.push(user.type === 2 ? '/place/' : '/people/');

        } catch (e) {
            console.log('error', e);
        }
    };

    return (
        <Grid stackable style={{border: '4px solid red', margin: '32px 0'}}>
            <Grid.Row columns={"two"}>
                <Grid.Column
                    only='large screen'
                    style={{
                        backgroundImage: 'url(/images/login-bg.jpg)',
                        backgroundPosition: 'top center',
                    }}
                />
                <Grid.Column className={"signup-form"} textAlign={"center"}>
                    <Image src={"/images/logo-footer-geral.png"} width={160}/>
                    <h3>Login</h3>
                    <p>Informe os dados abaixo para acessar o sistema.</p>
                    <Form onSubmit={handleSubmit(onSubmit)} loading={isSubmitting}>
                        <Form.Field>
                            <input
                                name={'username'}
                                ref={register({required: true})}
                                placeholder='E-mail'
                                defaultValue={''}
                                autoFocus
                            />
                        </Form.Field>
                        <Form.Field>
                            <input
                                name={'password'}
                                ref={register({required: true})}
                                type={'password'}
                                placeholder='Senha'
                                defaultValue={''}
                            />
                        </Form.Field>
                        <Button
                            type='submit'
                            disabled={!isValid || isSubmitting}
                            loading={isSubmitting}
                            color={"red"}
                            content={'ENTRAR'}
                        />
                    </Form>
                    <Divider section/>
                    <h2>Não possui cadastro no INBH?</h2>
                    <Button
                        basic
                        type={"button"}
                        color={"red"}
                        onClick={() => history.push('/users/signup')}
                        content={'CRIAR CONTA'}
                    />
                    <Divider section/>
                    <NavLink to={"/users/recover"}>Esqueci minha senha</NavLink>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}